import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useButton } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './MenuButton.module.scss';

const MenuButton = ({ open, ...props }) => {
    const intl = useIntl();
    const ref = useRef();
    const { buttonProps } = useButton({
        ...props
    }, ref);

    return (
        <button
            ref={ref}
            {...buttonProps}
            data-testid="navbar.menu.button"
            className={[
                'govuk-header__menu-button',
                styles.button
            ].join(' ')}
            aria-controls="navigation"
            aria-expanded={open ? 'true' : 'false'}
        >
            {intl.formatMessage({ id: 'navbar.menu.button' })}
        </button>
    );
};

MenuButton.prototype = {
    ...defaultAriaProps,
    onPress: PropTypes.func
};

export default MenuButton;
